// NOTE EXPORT THESE IN A UTILS FILE
export function incrementSlideIndex(slideIndex) {
  if (slideIndex < 2) {
    return slideIndex + 1
  } else if (slideIndex >= 2) {
    return 0
  }
}
export function decrementSlideIndex(slideIndex) {
  if (slideIndex > 0) {
    return slideIndex - 1
  } else if (slideIndex <= 0) {
    return 2
  }
}
